import * as React from "react";
import { forwardRef } from "react";
const SvgBack = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 8", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 3.5H1.915L4.71 0.705L4 0L0 4L4 8L4.705 7.295L1.915 4.5H8V3.5Z" }));
const ForwardRef = forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
